'use client'; // Error boundaries must be Client Components

import { useEffect, useRef, useState } from 'react';

// components
import {
  ITmErrorProps,
  TmError,
  tmErrorMockData500,
} from '@/components/templates';

// util
import { getErrorPageProps } from '@/lib/contentstack-sdk';
import { sendErrorGTMEvent } from '@/components/helpers/analytics/gtm';

export default function Error() {
  const [errorProps, setErrorProps] = useState<ITmErrorProps | null>(null);
  const hasSentToGtmRef = useRef(false);

  useEffect(() => {
    getErrorPageProps('500').then((result) => {
      if (result) {
        setErrorProps({
          heading: result.body.title,
          body: result.body.description,
          topSpacing: result.top_spacing.spacing_value,
          bottomSpacing: result.bottom_spacing.spacing_value,
        });
      }
    });
  }, []);

  useEffect(() => {
    if (!hasSentToGtmRef.current) {
      sendErrorGTMEvent(500);
      hasSentToGtmRef.current = true;
    }
  }, []);

  const props = errorProps ?? tmErrorMockData500;

  return (
    <>
      <title>Schumacher Homes | 500 Error - Server Error</title>
      <TmError
        heading={props.heading}
        topSpacing={props.topSpacing}
        bottomSpacing={props.bottomSpacing}
        body={props.body}
      />
    </>
  );
}
